'use strict';

export class AttachmentCtrl
{
	$filter;
	
	notify;
	
	field;
	
	cfg = {
		fileFilter: {
			pdf: true,
		},
		uploadUrl: '',
		removeUrl: '',
		addUrl: '',
	};
	
	attfile = {
		file: {}
	};
	
	uploadUrl = '';
	
	field = '';
	
	attachments = [];
	
	constructor($scope, $http, $mdDialog, $filter, notify, jsDataService){
		this.$scope = $scope;
		this.$http = $http;
		this.$mdDialog = $mdDialog;
		this.jsDataService = jsDataService;
		this.$filter = $filter;
		this.notify = notify;
		this.cfg.uploadUrl = jsDataService.get('cfgUploadUrl');
		this.cfg.addUrl = jsDataService.get('cfgAttachmentAddUrl');
		this.cfg.removeUrl = jsDataService.get('cfgAttachmentRemoveUrl');
		
		$scope.$watch(() => this.field, (newVal) => {
			if (newVal) {
				this.field = newVal;
			}
		});
		$scope.$watch(() => this.attachments, (newVal) => {
			if (newVal) {
				this.attachments = newVal;
			}
		});
	}
	
	fileAdded($file) {
		const ext = $file.getExtension().toLowerCase();
		// if (!this.cfg.fileFilter[ext]) {
		// 	this.notify(this.$filter('tr')('file_pdf_allowed'), true);
		// 	return false;
		// }

		if(typeof(this.cfg.maxFileSize) !== 'undefined' && $file.size > this.cfg.maxFileSize){
			this.notify($file.name + ' - ' + this.$filter('tr')('file_size_error'), true);
			return false;
		}

		if(!this.activeUpload()){
			return false;
		}

		this.addFlowFile($file);
		return true;
	}
	
	activeUpload(){
		return true;
	}
	
	addFlowFile($file){
		let file = {
			file_id: '0',
			nrId: $file.uniqueIdentifier,
			file_name: $file.name,
			isFlow: true,
			flowFile: $file,
			done: false
		};
		this.attfile.file = file;
	}
	
	fileSubmited(){
		this.attfile.flow.upload();
	}
	
	fileUploaded($file, $message, $flow){
		if($file.response.success){
			this.attfile.file.file_id = $file.response.fileId;
			this.attfile.file.done = true;
//			this.$scope.$parent.ctrl.onAttachmentUpload(this.field, this.attfile.file);
			this.saveAttachment(this.attfile);
		}
	}
	
	saveAttachment(attachment){
		let data = {
			file_id: attachment.file.file_id,
			title: attachment.file.file_name,
			field: this.field,
		};
		if(this.cfg.addUrl && this.cfg.addUrl !== ''){
			this.$scope.basicHttpConfigProcess({
				url: this.cfg.addUrl,
				method: 'POST',
				data: data
			}).then((response) => {
				console.log(response.data);
				if(response.data.success && typeof(response.data.item) !== 'undefined'){
					this.attachments.push(response.data.item);
					this.attfile.file = {};
				}
			}, () => {});
		}
		else{
			console.log('no url ', this.cfg.saveUrl);
		}
	}
	
	removeAttachment(event, attachment){
		this.$scope.basicHttpConfigProcess({
			url: this.cfg.removeUrl,
			method: 'GET',
			responseType: 'json',
			params: {
				id: attachment.id
			}
		}).then((results) => {
			if(results.data.success){
				this.attachments = this.$filter('filter')(this.attachments, {id: '!'+attachment.id}, true);
			}
		});
	}
}